import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import LanguageIcon from "@mui/icons-material/Language";
import SchoolIcon from "@mui/icons-material/School";
import PsychologyIcon from "@mui/icons-material/Psychology";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import CodeIcon from "@mui/icons-material/Code";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import ArticleIcon from "@mui/icons-material/Article";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";

export const AREA_CONFIG = {

  "periodismo": {
    icon: ArticleIcon,
    color: "#0F766E",
    description: "Comunicación, medios y técnicas periodísticas.",
  },

  "negocios digitales": {
    icon: LanguageIcon,
    color: "#0EA5E9",
    description: "Estrategias, marketing y modelos de negocio en internet.",
  },

  "mba economico": {
    icon: SchoolIcon,
    color: "#7C3AED",
    description: "Conceptos clave de administración y finanzas aplicadas.",
  },

  "habilidades gerenciales": {
    icon: BusinessCenterIcon,
    color: "#2563EB",
    description: "Liderazgo, gestión de equipos y toma de decisiones.",
  },

  "exito y desarrollo personal": {
    icon: EmojiEventsIcon,
    color: "#F59E0B",
    description: "Hábitos y mentalidad para alcanzar metas personales.",
  },

  "resiliencia": {
    icon: SelfImprovementIcon,
    color: "#10B981",
    description: "Fortaleza mental para superar desafíos y crecer.",
  },

  "psicologia": {
    icon: PsychologyIcon,
    color: "#EC4899",
    description: "Comprensión del comportamiento y la mente humana.",
  },

  "programacion": {
    icon: CodeIcon,
    color: "#111827",
    description: "Aprendizaje de desarrollo de software y tecnología.",
  },

  "biografias e inspiracion": {
    icon: AutoStoriesIcon,
    color: "#6366F1",
    description: "Historias reales que inspiran crecimiento personal.",
  },

  "emprendimiento": {
    icon: RocketLaunchIcon,
    color: "#F97316",
    description: "Creación y desarrollo de nuevos negocios.",
  },

  "historia del peru": {
    icon: HistoryEduIcon,
    color: "#DC2626",
    description: "Hechos y personajes clave de la historia peruana.",
  },

  General: {
    icon: AutoStoriesIcon,
    color: "#64748B",
    description: "Material educativo general.",
  },
};
